module.exports = __webpack_public_path__ + "static/media/delete.a73f8a07.svg";